import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import NFFilter from '../components/FilterContainer';
import FilterForm from '../components/FilterForm';
import CheckboxControl from '../components/CheckboxControl';
import { STATUS, statusEnumTransKey } from '../enums';

import { Container } from '../styles';

const label = Object.values(STATUS);

const Status = ({ isOpen, onClick, onApply, status }) => {
  const [selectedItem, setSelectedItem] = useState(status);

  useEffect(() => {
    if(status?.length < 1) {
      setSelectedItem([]);
    }
  }, [status]);

  const handleChange = e => {
    if (!e.target.checked) {
      setSelectedItem(
        selectedItem.filter(item => Number(item) !== Number(e.target.value)),
      );
    } else if (e.target.checked) {
      setSelectedItem([...selectedItem, e.target.value]);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    onApply(selectedItem);
  };

  const clearFilter = () => {
    setSelectedItem([]);
    onApply([]);
  };

  return (
    <NFFilter label="Status" isOpen={isOpen} onClick={onClick}>
      <FilterForm
        label="Filtrar por status"
        onSubmit={handleSubmit}
        clearFilter={clearFilter}
      >
        <Container>
          {label.map((filter, idx) => (
            <CheckboxControl
              key={Number(idx)}
              value={filter}
              onChange={handleChange}
              defaultChecked={selectedItem.some(
                item => parseInt(item) === filter,
              )}
              label={statusEnumTransKey[filter]}
            />
          ))}
        </Container>
      </FilterForm>
    </NFFilter>
  );
};

const mapStateToProps = state => ({
  status: state.tracking.filters.listStatus,
});

export default connect(mapStateToProps)(Status);
